import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { TABLE_COLUMNS } from './constants';

import { List } from '../domain';

type FormattedValue = string | number;

export const sortLists = (
  lists: List[],
  sortBy: string = TABLE_COLUMNS.NAME,
  sortDirection: SORT_DIRECTIONS,
) =>
  lists.sort((list1: List, list2: List) => {
    let formattedValue1: FormattedValue = list1.name.toLowerCase();
    let formattedValue2: FormattedValue = list2.name.toLowerCase();

    if (sortBy === TABLE_COLUMNS.TYPE) {
      formattedValue1 = list1.emailListType.toLowerCase();
      formattedValue2 = list2.emailListType.toLowerCase();
    }

    if (sortDirection === SORT_DIRECTIONS.DESCENDING) {
      return formattedValue1 > formattedValue2 ? -1 : 1;
    }
    return formattedValue2 > formattedValue1 ? -1 : 1;
  });
